import React, { useState, useEffect } from "react";
import { googleLogin, logout } from "../Shared/firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useDispatch, useSelector } from 'react-redux';
import { get_user_from_mail } from "../api/userAuth";

const GoogleAuth = () => {
  const [user, setUser] = useState(null);
  const auth = getAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (user) {
      const data = {
        email: user?.email,
        name: user?.displayName,
        photoURL: user?.photoURL,
      };
      dispatch(get_user_from_mail(data));
    }
  }, [user]);

  const handleGoogleLogin = async () => {
    const userData = await googleLogin();
    if (userData) {
      setUser(userData); // useEffect above handles the dispatch — no duplicate call here
    }
  };

  const handleLogout = async () => {
    await logout();
    setUser(null);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-96 mt-2 font-lato">
      {user ? (
        <div className="bg-white shadow-md rounded-lg p-6 text-center"></div>
      ) : (
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 transition"
        >
          <img src="https://img.icons8.com/color/48/google-logo.png" alt="Google" className="w-6 h-6 mr-2" />
          Login with Google
        </button>
      )}
    </div>
  );
};

export default GoogleAuth;